import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './DrawerToggle.styles';
import { Icon } from '../../icons';
import { IconButton } from '../../buttons';

const DrawerToggle = ({ opened, onDrawerToggle }) => {
  const classes = useStyles();

  return (
    <IconButton id="openButton" onClick={onDrawerToggle} className={opened ? classes.openedButton : classes.closedButton}>
      <Icon icon={opened ? 'arrow_back' : 'arrow_forward'} className={classes.icon} />
    </IconButton>
  );
};

DrawerToggle.propTypes = {
  onDrawerToggle: PropTypes.func.isRequired,
  opened: PropTypes.bool,
};

DrawerToggle.defaultProps = {
  opened: false,
};

export default React.memo(DrawerToggle);
